import axios from "axios";
import { API } from "./api";
export const adminApi = axios.create({ baseURL: API, withCredentials: true });
let refreshRequest;
adminApi.interceptors.response.use(response => response, async error => {
  const request = error.config;
  const eligible = request?.url?.startsWith("/admin/") || request?.url === "/auth/me";
  if (error.response?.status !== 401 || request?.retried || !eligible) throw error;
  request.retried = true;
  if (!refreshRequest) refreshRequest = adminApi.post("/auth/refresh").finally(() => { refreshRequest = null; });
  await refreshRequest;
  return adminApi(request);
});